var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Примеры посадок")]),_c('cards-list'),_c('favorite')],1)}
var staticRenderFns = []

export { render, staticRenderFns }